import * as Yup from 'yup';
import { convertApiToDate } from '../../functions';

export function getValidationSchema(){
    return(
        Yup.object().shape({
            selectedDate: Yup.mixed().test(
                'selectedDateIsDate',
                'Invalid date',
                (value) => !isNaN(new Date(value).getTime())
            ).test(
                'selectedDateIsValid',
                'Selected date cannot be in the future',
                (value) => {
                    const date = convertApiToDate(value);
                    const today = new Date();
                    return date <= today;
                }
            ),
            checkTimesValid: Yup.mixed().when(['timeIn', 'timeOut', 'timeOutNull'],
                ([timeIn, timeOut, timeOutNull]) => {
                    // If "No Out Time" is checked, validation passes
                    if(timeOutNull) return Yup.mixed().test('checkTimesValid', '', () => true);
                    
                    // Check if times are valid numbers
                    const isValid1 = !isNaN(timeIn.raw) && !isNaN(timeOut.raw);
                    if(!isValid1) return Yup.mixed().test('checkTimesValid', `At least one time is invalid`, () => false);
                    
                    // Allow time out to be less than time in (overnight shift - time out is next day)
                    // Both cases are valid: timeIn < timeOut (same day) OR timeOut < timeIn (overnight)
                    // The only invalid case would be if they're exactly equal, but that's unlikely
                    // For overnight shifts, time out will be on the next day, so timeOut < timeIn is valid
                    const isValid2 = (timeIn.raw !== timeOut.raw); // Times must be different
                    if(!isValid2) return Yup.mixed().test('checkTimesValid', `Time in and time out cannot be the same`, () => false);
                    
                    return Yup.mixed().test('checkTimesValid', '', () => true);
                }
            ),
        })
    );
}